import { createSlice } from "@reduxjs/toolkit";
import {
  deleteGroupReport,
  fetchGroupReport,
  warnToReportedGroup,
  blockUnblockedGroupAdmin
} from "../action/groupReportAction";

const initialState = {
  isLoading: false,
  allGroupReportList: [],
};

export const reportGroupSlice = createSlice({
  name: "reportGroup",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get-all-report-group
    builder.addCase(fetchGroupReport.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchGroupReport.fulfilled, (state, action) => {
      const { data, success } = action?.payload ?? [];
      state.allGroupReportList = data;
      state.isLoading = false;
    });
    builder.addCase(fetchGroupReport.rejected, (state, action) => {
      state.isLoading = false;
    });

    // delete-group-report
    builder.addCase(deleteGroupReport.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteGroupReport.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteGroupReport.rejected, (state, action) => {
      state.isLoading = false;
    });

    // warnToReportedGroup
    builder.addCase(warnToReportedGroup.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(warnToReportedGroup.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(warnToReportedGroup.rejected, (state, action) => {
      state.isLoading = false;
    });

    // blockUnblockedGroupAdmin 
    builder.addCase(blockUnblockedGroupAdmin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(blockUnblockedGroupAdmin.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(blockUnblockedGroupAdmin.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default reportGroupSlice.reducer;
